<template>
  <div class="datos container text m-y-2-sm m-y-3-md">
    <h2 class="titulo">Datos</h2>
    <p>
      En esta sección es posible descargar la información (tablas y metadatos)
      contenida en el mapa de “Comunidad involucrada en la atención, adaptación
      y mitigación de sargazo”, el cual se encuentra en la pestaña de Inicio.
    </p>
    <a
      class="btn btn-descarga boton-simplificado m-y-1"
      :href="`${cdnArchivosSargazo}/comunidad-involucrada-en-adaptacion-y-mitigacion-de-sargazo-en-mexico-y-otros-paises.zip`"
      download="comunidad-involucrada-en-adaptacion-y-mitigacion-de-sargazo-en-mexico-y-otros-paises.zip"
    >
      <span class="titulo-link"> Archivo de descarga </span>
      <br />
      <small>
        El zip contiene la información del mapa de actores en formato GeoPackage
        (gpkg) con sus tablas correspondientes en formato csv y sus metadatos en
        formato txt
      </small>
      <span class="icono icono-descargar ocultar-vista-simplificada"></span>
    </a>

    <div
      class="container text m-t-1-sm m-b-3-sm m-y-2-md a11y-simplificada-block"
    >
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSdM2lwTbT7jA2Hz31cPtHrMvU3FWz62U7gBeFj99tVSIq-YAA/viewform"
      >
        <b>Encuesta pública</b>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Datos",
  computed: mapGetters(["cdnArchivosSargazo"]),
};
</script>

<style lang="scss" scoped>
.datos {
  .btn-descarga {
    background: #9d4637;
    display: block;
    border-radius: 10px;
    width: 100%;
    padding: $gap $gap * 3 $gap $gap;
    position: relative;
    .icono {
      position: absolute;
      right: $gap;
      top: calc(50% - 15px);
      background: transparent;
      color: #fff;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
    }
  }
}
</style>